const CAP13 = {
  id: 13,
  slug: "cap13-blockchain-consorcio",
  title: "Capítulo 13 — Características de la Blockchain de Consorcio",
  sections: [
    {
      heading: "¿Qué es una blockchain de consorcio?",
      text: [
        "Una blockchain de consorcio es un modelo intermedio entre una blockchain pública y una privada.",
        "En lugar de que cualquier persona pueda participar (como en las blockchains públicas), o que una sola entidad tenga el control total (como en las privadas), en la blockchain de consorcio el control se reparte entre **varias organizaciones confiables**.",
        "Estas organizaciones colaboran para validar transacciones, gestionar la red y mantener la seguridad, creando un sistema más equilibrado entre **privacidad, colaboración y transparencia controlada**.",
        "Por eso, este tipo de blockchain es ideal cuando **varias instituciones deben trabajar juntas, compartiendo información de forma segura**, sin exponerla completamente al público."
      ]
    },
    {
      heading: "¿Dónde se usa una blockchain de consorcio?",
      text: [
        "Las blockchains de consorcio son especialmente útiles en sectores donde hay varias empresas o entidades que necesitan:",
        "🔹 Compartir información.",
        "🔹 Validar transacciones entre sí.",
        "🔹 Mantener los datos privados del público.",
        "Esto ocurre, por ejemplo, en los sectores financiero, logístico, salud, seguros, educación o comercio internacional."
      ]
    },
    {
      heading: "Ejemplo real: Corda (R3)",
      text: [
        "**Corda**, diseñada por la empresa R3, es uno de los ejemplos más conocidos de blockchain de consorcio.",
        "Fue creada específicamente para el sector financiero y actualmente es utilizada por decenas de bancos y entidades institucionales.",
        "Corda permite:",
        "🔹 Registrar transacciones entre bancos de forma segura.",
        "🔹 Mantener la privacidad entre las partes involucradas.",
        "🔹 Automatizar procesos mediante contratos inteligentes.",
        "🔹 Evitar intermediarios y reducir costos."
      ]
    },
    {
      heading: "Ventajas de las blockchains de consorcio",
      list: [
        " **Eficiencia:** al limitar el número de participantes, las transacciones pueden procesarse más rápidamente que en una blockchain pública.",
        " **Confianza compartida:** no pertenece a una sola empresa, sino a un grupo que colabora y valida las operaciones.",
        " **Ahorro de tiempo y recursos:** las organizaciones comparten infraestructura, experiencias y soluciones.",
        " **Privacidad y seguridad:** solo los miembros del consorcio tienen acceso a la información sensible.",
        " **Cumplimiento regulatorio:** permite privacidad y control, algo esencial para sectores regulados como bancos, salud y gobierno."
      ]
    },
    {
      heading: "Desventajas de las blockchains de consorcio",
      list: [
        "⚠️ **Gobernanza compleja:** la toma de decisiones puede ser complicada al necesitar acuerdo entre varias instituciones.",
        "⚠️ **Descentralización limitada:** aunque no depende de una sola entidad, sigue estando limitada a un grupo seleccionado de participantes.",
        "⚠️ **Posible riesgo de manipulación:** si un nodo importante es comprometido, la seguridad del consorcio puede verse afectada.",
        "⚠️ **Poca flexibilidad:** los cambios en las reglas o tecnología requieren coordinación entre todos los miembros."
      ]
    },
    {
      heading: "Ejemplo explicado paso a paso",
      text: [
        "Imagina que cinco bancos se unen para crear una blockchain de consorcio. No quieren una red pública como Bitcoin, porque ciertos datos financieros deben mantenerse privados.",
        "Tampoco desean que solo un banco controle la red, porque eso generaría desconfianza.",
        "Entonces acuerdan:",
        "🔹 Crear una blockchain compartida.",
        "🔹 Cada banco tiene un nodo validador.",
        "🔹 Solo ellos pueden ver y validar transacciones.",
        "🔹 Las reglas se acuerdan entre todos.",
        "Así, los bancos pueden hacer transferencias, verificar identidad de clientes, registrar préstamos y compartir información auditada, todo de manera segura, privada y colaborativa."
      ]
    },
    {
      heading: "Conclusión",
      text: [
        "La blockchain de consorcio se presenta como una opción ideal para **colaboraciones entre organizaciones que necesitan confianza, transparencia limitada y privacidad real**.",
        "Combina lo mejor de las blockchains públicas (transparencia y seguridad criptográfica) con las privadas (control, privacidad y gobierno organizado).",
        "Por eso se está convirtiendo en una de las alternativas más adoptadas por sectores financieros, logísticos, gubernamentales, industriales y educativos."
      ]
    }
  ]
};

export default CAP13;
